var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.sectionVisible
    ? _c(
        "div",
        [
          _c("section-title", { staticClass: "mt-2" }, [
            _vm._v("\n    " + _vm._s(_vm.applicantName) + ",\n    "),
            _c("span", { staticClass: "text-lowercase" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "application-standalone.pages.incomeHistory.tellUsAboutYourIncome"
                    )
                  ) +
                  "\n    "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _vm.incomeCurrentJobVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.incomeHistory.currentJob"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("currentJob.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("radio-field", {
                            attrs: {
                              value: _vm.currentJob,
                              options: _vm.yesNoOptions,
                              validator: _vm.getValidator("currentJob"),
                            },
                            on: {
                              "update:value": function ($event) {
                                _vm.currentJob = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.incomeSelfEmployedVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.incomeHistory.selfEmployed"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("selfEmployed.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("radio-field", {
                            attrs: {
                              value: _vm.selfEmployed,
                              options: _vm.yesNoOptions,
                              validator: _vm.getValidator("selfEmployed"),
                            },
                            on: {
                              "update:value": function ($event) {
                                _vm.selfEmployed = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.incomeOccupationVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.incomeHistory.occupation"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("occupation.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-field", {
                            attrs: {
                              value: _vm.occupation,
                              options: _vm.applicantOccupationOptions,
                              placeholder: _vm.$t(
                                "application-standalone.questions.incomeHistory.occupation"
                              ),
                              validator: _vm.getValidator("occupation"),
                            },
                            on: {
                              "update:value": function ($event) {
                                _vm.occupation = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _vm.incomeEmployerNameVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.currentFlow ===
                                      _vm.APPLICATION_FLOW.SWITCH_TRANSFER
                                      ? _vm.$t(
                                          "application-standalone.labels.businessName"
                                        )
                                      : _vm.$t(
                                          "application-standalone.questions.incomeHistory.employerName"
                                        )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("employerName.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("address-autocomplete-field", {
                            attrs: {
                              value: _vm.employerName,
                              placeholder: _vm.$t(
                                "application-standalone.labels.businessName"
                              ),
                              "auto-fill": "off",
                              "auto-complete": "off",
                              "company-address-mode": "",
                              "max-length": 40,
                              "on-type": "",
                              validator: _vm.getValidator("employerName"),
                              label: _vm.$t(
                                "application-standalone.labels.businessName"
                              ),
                              "hidden-label": "",
                            },
                            on: {
                              "update:value": function ($event) {
                                _vm.employerName = $event
                              },
                              autocomplete:
                                _vm.handleEmployerAddressAutocomplete,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.incomeAddressVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            { staticClass: "mb-4" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.labels.businessAddress"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("employmentAddress.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  attrs: { id: "businessAddressTooltipTarget" },
                                },
                                [
                                  _c("icon", {
                                    staticClass:
                                      "text-primary small clickable ml-1",
                                    attrs: { name: "info-circle" },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("notification-popover", {
                                attrs: {
                                  target: "businessAddressTooltipTarget",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "popoverContent",
                                      fn: function () {
                                        return [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "application-standalone.pages.incomeHistory.address"
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1792177186
                                ),
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("address-field-group", {
                            attrs: {
                              line1: _vm.employmentAddress.line1,
                              line2: _vm.employmentAddress.line2,
                              "unit-number":
                                _vm.employmentAddress["unit-number"],
                              province: _vm.employmentAddress.province,
                              city: _vm.employmentAddress.city,
                              "postal-code":
                                _vm.employmentAddress["postal-code"],
                              "street-direction":
                                _vm.employmentAddress["street-direction"],
                              "street-name":
                                _vm.employmentAddress["street-name"],
                              "street-number":
                                _vm.employmentAddress["street-number"],
                              "street-type":
                                _vm.employmentAddress["street-type"],
                              "time-at": _vm.employmentAddress["time-at"],
                              validator: _vm.getValidator("employmentAddress"),
                              label: _vm.$t(
                                "application-standalone.labels.businessAddress"
                              ),
                              "hidden-label": "",
                              "show-required-indicator": "",
                            },
                            on: {
                              "update:line1": function ($event) {
                                return _vm.$set(
                                  _vm.employmentAddress,
                                  "line1",
                                  $event
                                )
                              },
                              "update:line2": function ($event) {
                                return _vm.$set(
                                  _vm.employmentAddress,
                                  "line2",
                                  $event
                                )
                              },
                              "update:unitNumber": function ($event) {
                                return _vm.$set(
                                  _vm.employmentAddress,
                                  "unit-number",
                                  $event
                                )
                              },
                              "update:unit-number": function ($event) {
                                return _vm.$set(
                                  _vm.employmentAddress,
                                  "unit-number",
                                  $event
                                )
                              },
                              "update:province": function ($event) {
                                return _vm.$set(
                                  _vm.employmentAddress,
                                  "province",
                                  $event
                                )
                              },
                              "update:city": function ($event) {
                                return _vm.$set(
                                  _vm.employmentAddress,
                                  "city",
                                  $event
                                )
                              },
                              "update:postalCode": function ($event) {
                                return _vm.$set(
                                  _vm.employmentAddress,
                                  "postal-code",
                                  $event
                                )
                              },
                              "update:postal-code": function ($event) {
                                return _vm.$set(
                                  _vm.employmentAddress,
                                  "postal-code",
                                  $event
                                )
                              },
                              "update:streetDirection": function ($event) {
                                return _vm.$set(
                                  _vm.employmentAddress,
                                  "street-direction",
                                  $event
                                )
                              },
                              "update:street-direction": function ($event) {
                                return _vm.$set(
                                  _vm.employmentAddress,
                                  "street-direction",
                                  $event
                                )
                              },
                              "update:streetName": function ($event) {
                                return _vm.$set(
                                  _vm.employmentAddress,
                                  "street-name",
                                  $event
                                )
                              },
                              "update:street-name": function ($event) {
                                return _vm.$set(
                                  _vm.employmentAddress,
                                  "street-name",
                                  $event
                                )
                              },
                              "update:streetNumber": function ($event) {
                                return _vm.$set(
                                  _vm.employmentAddress,
                                  "street-number",
                                  $event
                                )
                              },
                              "update:street-number": function ($event) {
                                return _vm.$set(
                                  _vm.employmentAddress,
                                  "street-number",
                                  $event
                                )
                              },
                              "update:streetType": function ($event) {
                                return _vm.$set(
                                  _vm.employmentAddress,
                                  "street-type",
                                  $event
                                )
                              },
                              "update:street-type": function ($event) {
                                return _vm.$set(
                                  _vm.employmentAddress,
                                  "street-type",
                                  $event
                                )
                              },
                              "update:timeAt": function ($event) {
                                return _vm.$set(
                                  _vm.employmentAddress,
                                  "time-at",
                                  $event
                                )
                              },
                              "update:time-at": function ($event) {
                                return _vm.$set(
                                  _vm.employmentAddress,
                                  "time-at",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.incomeOperatingAsVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.incomeHistory.operatingAs"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("operatingAs.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("radio-field", {
                            attrs: {
                              value: _vm.operatingAs,
                              options: _vm.applicantOperatingAsOptions,
                              validator: _vm.getValidator("operatingAs"),
                            },
                            on: {
                              "update:value": function ($event) {
                                _vm.operatingAs = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _vm.incomeJobTitleVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.incomeHistory.jobTitle"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("jobTitle.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("text-field", {
                            attrs: {
                              value: _vm.jobTitle,
                              placeholder: _vm.$t("application-form.job-title"),
                              "max-length": 50,
                              validator: _vm.getValidator("jobTitle"),
                              label: _vm.$t("application-form.job-title"),
                              "hidden-label": "",
                            },
                            on: {
                              "update:value": function ($event) {
                                _vm.jobTitle = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.incomeEmploymentTypeVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.incomeHistory.employmentType"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("employmentType.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-field", {
                            attrs: {
                              value: _vm.employmentType,
                              placeholder: _vm.$t(
                                "application-form.employment-type"
                              ),
                              options: _vm.applicantEmploymentTypeOptions,
                              validator: _vm.getValidator("employmentType"),
                            },
                            on: {
                              "update:value": function ($event) {
                                _vm.employmentType = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.incomeIncomeTypeVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.incomeHistory.incomeType"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("incomeType.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-field", {
                            attrs: {
                              value: _vm.incomeType,
                              placeholder: _vm.$t(
                                "application-form.income-type"
                              ),
                              options: _vm.applicantIncomeTypeOptions,
                              validator: _vm.getValidator("incomeType"),
                            },
                            on: {
                              "update:value": function ($event) {
                                _vm.incomeType = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _vm.incomeGrossRevenueVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.incomeHistory.grossRevenue"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("grossRevenue.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("currency-field", {
                            attrs: {
                              value: _vm.grossRevenue,
                              validator: _vm.getValidator("grossRevenue"),
                              label: _vm.$t(
                                "application-standalone.questions.incomeHistory.grossRevenue"
                              ),
                              "hidden-label": "",
                            },
                            on: {
                              "update:value": function ($event) {
                                _vm.grossRevenue = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _vm.incomeIncomeAmountVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.incomeHistory.incomeAmount"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("incomeAmount.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("currency-field", {
                            attrs: {
                              value: _vm.incomeAmount,
                              placeholder: _vm.$t(
                                "application-form.income-amount"
                              ),
                              validator: _vm.getValidator("incomeAmount"),
                              label: _vm.$t(
                                "application-standalone.questions.incomeHistory.incomeAmount"
                              ),
                              "hidden-label": "",
                            },
                            on: {
                              "update:value": function ($event) {
                                _vm.incomeAmount = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.incomeIncomePeriodVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.incomeHistory.incomePeriod"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("incomePeriod.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-field", {
                            attrs: {
                              value: _vm.incomePeriod,
                              placeholder: _vm.$t(
                                "application-standalone.questions.incomeHistory.incomePeriod"
                              ),
                              options: _vm.applicantIncomePeriodOptions,
                              validator: _vm.getValidator("incomePeriod"),
                            },
                            on: {
                              "update:value": function ($event) {
                                _vm.incomePeriod = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _vm.incomeTimeAtJobVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t("application-form.time-at-job")
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("timeAtJob.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("time-at-field-group", {
                            attrs: {
                              value: _vm.timeAtJob,
                              validator: _vm.getValidator("timeAtJob"),
                              "has-warning": _vm.hasTimeAtJobWarning,
                              "warning-message": _vm.$t(
                                "form-validations.total36MonthsEmployment"
                              ),
                            },
                            on: {
                              "update:value": function ($event) {
                                _vm.timeAtJob = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.incomeMonthsInIndustryVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.incomeHistory.monthsInIndustry"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("monthsInIndustry.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("time-at-field-group", {
                            attrs: {
                              value: _vm.monthsInIndustry,
                              validator: _vm.getValidator("monthsInIndustry"),
                            },
                            on: {
                              "update:value": function ($event) {
                                _vm.monthsInIndustry = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.incomeWorkPhoneVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.incomeHistory.workPhone"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("employmentWorkPhone.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("text-field", {
                            attrs: {
                              value: _vm.employmentWorkPhone,
                              "mask-type": "phone-ext",
                              placeholder: _vm.$t(
                                "application-form.employer-phone-number"
                              ),
                              validator: _vm.getValidator(
                                "employmentWorkPhone"
                              ),
                              label: _vm.$t(
                                "application-form.employer-phone-number"
                              ),
                              "hidden-label": "",
                            },
                            on: {
                              "update:value": function ($event) {
                                _vm.employmentWorkPhone = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _vm.incomeCompanyTypeVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.incomeHistory.companyType"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("companyType.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("text-field", {
                            attrs: {
                              value: _vm.companyType,
                              placeholder: _vm.$t(
                                "application-form.company-type"
                              ),
                              "max-length": 35,
                              validator: _vm.getValidator("companyType"),
                              label: _vm.$t("application-form.company-type"),
                              "hidden-label": "",
                            },
                            on: {
                              "update:value": function ($event) {
                                _vm.companyType = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.incomeIndustrySectorVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "page-section-group-layout",
                        [
                          _c(
                            "section-title",
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-standalone.questions.incomeHistory.industrySector"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _vm.getValidator("industrySector.required")
                                ? _c("input-required-indicator")
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-field", {
                            attrs: {
                              value: _vm.industrySector,
                              options: _vm.applicantIndustrySectorOptions,
                              placeholder: _vm.$t(
                                "application-form.industry-sector"
                              ),
                              validator: _vm.getValidator("industrySector"),
                              label: _vm.$t("application-form.industry-sector"),
                              "hidden-label": "",
                            },
                            on: {
                              "update:value": function ($event) {
                                _vm.industrySector = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }